import './DebouncedInput.scss';
import { Clear, Input } from '@mui/icons-material';
import { TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton/IconButton';
import InputAdornment from '@mui/material/InputAdornment/InputAdornment';
import React, { ChangeEvent, useEffect, useState } from 'react';

type DebouncedInputProps = {
  onChangeValue: (event: ChangeEvent<HTMLInputElement>) => void;
  debounceTime?: number;
  placeholder?: string;
  value?: string;
  focused?: boolean;
  id?: string;
  enableClear?: boolean;
};

const DebouncedInput: React.FC<DebouncedInputProps> = ({
  onChangeValue,
  debounceTime = 500,
  placeholder,
  value = '',
  focused,
  id,
  enableClear,
}) => {
  const [inputValue, setInputValue] = useState(value);

  // When parent value changes, update local input (e.g., on filter reset)
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      onChangeValue({
        target: { value: inputValue },
      } as ChangeEvent<HTMLInputElement>);
    }, debounceTime);

    return () => clearTimeout(handler);
  }, [inputValue]);

  return (
    // add a clear x icon if enableClear is true, inside the text input
    <div className="debounced-input-container">

      <TextField
        id={id}
        type="text"
        placeholder={placeholder}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        autoFocus={focused}
        InputProps={{
          endAdornment: enableClear && inputValue ? (
            <InputAdornment position="end">
              <IconButton
                onClick={() => {
                  setInputValue('');
                  onChangeValue({ target: { value: '' } } as ChangeEvent<HTMLInputElement>);
                }}
              >
                <Clear />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    </div>
  );
};

export default DebouncedInput;
